import { Theme } from "@mui/material";
import { FONT_SECONDARY } from "@/theme/typography";

export const getDropDownMenuStyles = (maxHeight: number, isLargeDesktop: boolean) => ({
  boxSizing: 'border-box',
  left: '50% !important',
  transform: 'translateX(-50%) !important',
  maxWidth: "calc(100% - 4px) !important",
  maxHeight: `calc(100% - ${maxHeight}px)`,
  width: '100%',
  padding: isLargeDesktop ? 5 : 3,

  boxShadow: '0 16.140981674194336px 12.912784576416016px 0 rgba(0,0,0,.04)',
  border: '1px solid transparent',
  borderTopColor: '#E3E6EB',

  "&::-webkit-scrollbar": {
    width: "6px",
    backgroundColor: "#f5f5f5",
  },
  "&::-webkit-scrollbar-track": {
    background: "#fff",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "lightgray",
    borderRadius: "20px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "gray",
    cursor: "pointer",
  },
})

export const getButtonStyles = ((theme: Theme) => ({
  padding: "30px 16px",
  fontFamily: FONT_SECONDARY,
  fontSize: 16,
  fontWeight: 500,
  "&:hover": {
    color: theme.palette.action.hover,
  },
  "&:focus": {
    color: theme.palette.action.hover,
  },
}));